import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["body", "send", "emailFrom", "emailReply", "emailChangeDiv", "emailChangeField"]
  static values = { autoShow: Boolean }

  connect() {
    if (this.autoShowValue) {
      this.showForm()
    }
  }

  showForm(event) {
    event?.preventDefault()
    if (this.sendTarget.classList.contains("hidden")) {
      this.bodyTarget.classList.add("hidden")
      this.sendTarget.classList.remove("hidden")
    }
  }

  hide() {
    if (this.bodyTarget.classList.contains("hidden")) {
      this.sendTarget.classList.add("hidden")
      this.bodyTarget.classList.remove("hidden")
      this.bodyTarget.scrollIntoView()
    }
  }

  changeReplyTo() {
    const select = this.emailFromTarget
    this.emailReplyTarget.value = select.options[select.selectedIndex].text
  }

  emailChange() {
    this.emailChangeDivTarget.classList.remove("hidden")
    this.emailChangeFieldTarget.disabled = false
  }

  preventEnterSubmit(event) {
    if (event.key === "Enter" && event.target.tagName !== "TEXTAREA") {
      event.preventDefault()
    }
  }
}
